// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qx-0";